export enum CreateTeamFields {
  TEAM_NAME = 'teamName',
  TEAM_GOAL = 'teamGoal',
  PRIVACY_SETTINGS = 'privacySettings',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}
